// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cql_main__vimo2 {
  width: 80%;
  margin: auto;
}
.Cql_card__i1qD0 {
  margin-bottom: 3rem;
  width: 100%;
}
.Cql_formTextLabel__H1YjR {
  text-align: justify;
  line-height: 1.2rem;
}
.Cql_formLabel__t7mTE {
  margin: 0 1rem 1rem 0;
  text-align: justify;
  line-height: 1.2rem;
}
.Cql_badgeContainer__iKdCH {
  width: 100%;
}
.Cql_tagMargin__nnYl0 {
  padding: 0 0 0 1rem;
  margin-top: 0rem !important;
}
.Cql_buttonPadding__q-l2- {
  display: flex;
  gap: 1rem;
}
.Cql_formText__tKzGf {
  margin-bottom: 0.25rem;
}
.Cql_noResizeTextArea__UTJhj {
  resize: none;
  height: 75vh;
  width: 100%;
}
.Cql_flexStartAlertIcon__YVuNt {
  display: flex;
  align-items: center;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Cql/Cql.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".main {\n  width: 80%;\n  margin: auto;\n}\n.card {\n  margin-bottom: 3rem;\n  width: 100%;\n}\n.formTextLabel {\n  text-align: justify;\n  line-height: 1.2rem;\n}\n.formLabel {\n  margin: 0 1rem 1rem 0;\n  text-align: justify;\n  line-height: 1.2rem;\n}\n.badgeContainer {\n  width: 100%;\n}\n.tagMargin {\n  padding: 0 0 0 1rem;\n  margin-top: 0rem !important;\n}\n.buttonPadding {\n  display: flex;\n  gap: 1rem;\n}\n.formText {\n  margin-bottom: 0.25rem;\n}\n.noResizeTextArea {\n  resize: none;\n  height: 75vh;\n  width: 100%;\n}\n.flexStartAlertIcon {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Cql_main__vimo2`,
	"card": `Cql_card__i1qD0`,
	"formTextLabel": `Cql_formTextLabel__H1YjR`,
	"formLabel": `Cql_formLabel__t7mTE`,
	"badgeContainer": `Cql_badgeContainer__iKdCH`,
	"tagMargin": `Cql_tagMargin__nnYl0`,
	"buttonPadding": `Cql_buttonPadding__q-l2-`,
	"formText": `Cql_formText__tKzGf`,
	"noResizeTextArea": `Cql_noResizeTextArea__UTJhj`,
	"flexStartAlertIcon": `Cql_flexStartAlertIcon__YVuNt`
};
export default ___CSS_LOADER_EXPORT___;
